import { useState } from "react";
import { NAV_LINKS } from "../data";
import { trackNavClick, trackMobileMenuOpen } from "../analytics";

export default function Nav() {
  const [open, setOpen] = useState(false);

  const handleMenuOpen = () => {
    const next = !open;
    setOpen(next);
    if (next) trackMobileMenuOpen();
  };

  return (
    <>
      <nav className="nav-bar">
        <a href="/" className="nav-brand">
          <img src="/logo.png" alt="Wychodzi" />
          <span className="nav-brand-name">Wychodzi</span>
        </a>

        <div style={{ flex: 1 }} />

        <div className="nav-desktop-links">
          {NAV_LINKS.map(({ href, label }) => (
            <a
              key={href}
              href={href}
              className="nav-link"
              onClick={() => trackNavClick(href, label)}
            >
              {label}
            </a>
          ))}
        </div>

        {/* Gradient-border CTA — same trick as mobile auth buttons */}
        <a
          href="#download"
          className="nav-desktop-cta nav-cta-pill"
          onClick={() => trackNavClick("#download", "Скачать приложение")}
        >
          <span className="nav-cta-inner">
            <span className="nav-cta-long">Скачать приложение</span>
            <span className="nav-cta-short">Скачать</span>
          </span>
        </a>

        <button
          className={`nav-hamburger ${open ? "open" : ""}`}
          onClick={handleMenuOpen}
          aria-label={open ? "Закрыть меню" : "Открыть меню"}
        >
          <span /><span /><span />
        </button>
      </nav>

      <div className={`mobile-menu ${open ? "open" : ""}`} role="dialog" aria-label="Мобильное меню">
        {NAV_LINKS.map(({ href, label }) => (
          <a
            key={href}
            href={href}
            className="mobile-menu-link"
            onClick={() => { setOpen(false); trackNavClick(href, label); }}
          >
            {label}
          </a>
        ))}
        <a
          href="#download"
          className="mobile-menu-cta"
          onClick={() => { setOpen(false); trackNavClick("#download", "Скачать приложение"); }}
        >
          Скачать приложение
        </a>
      </div>
    </>
  );
}
